import { Box, FormGroup, Grid, Modal, Typography,
  IconButton,
} from "@mui/material";
import Crossicon from "../../Icon/Crossicon";
import { apiErrorMessage } from "../../helper/apiError";
import CloseIcon from "@mui/icons-material/Close";
import { fontSize } from "../theme/fontSize";
import { fontWeight } from "../theme/fontWeight";
import { FontFamily } from "../theme/fontFamily";
import { ThemeColor } from "../theme/color";
import { Formik, Form } from "formik";
import CustomButton from "../button/button";
import OutlinedInputField from "../inputfiled/OutlinedInput";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetFilteredUserAction,
  GetUserChatAction,
} from "../../Redux/action/SettingAction";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import CustomSelect from "../select field/OutlinedSelectField";
import {
  AddGroupChatService,
  AddPersonChatService,
  AddPersonToGroupChatService,
} from "../../Redux/service/SettingService";
import CustomizedFilterAutoComplete from "../autocomplete/FilterAutocomplete";
import MultiSelectAutocomplete from "../autocomplete/FilterAutocomplete";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "94%", sm: 520, md: 560 },
  maxWidth: "100%",
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  borderRadius: "16px",
  boxShadow: "0 24px 60px rgba(16, 24, 40, 0.22)",
  p: { xs: 2.5, sm: 3 },
  outline: "none",
  '&::-webkit-scrollbar': { width: '8px' },
  '&::-webkit-scrollbar-track': { background: '#f1f1f1', borderRadius: '10px' },
  '&::-webkit-scrollbar-thumb': { background: '#888', borderRadius: '10px' },
  '&::-webkit-scrollbar-thumb:hover': { background: '#555' },
};

export const AddPersonToChatChatModal = ({
  AddPersonChat,
  handleClose,
  chatId,
  Participantlist,
  stdId,
  Organizationlist,
  Rolelist,
}) => {
  const dispatch = useDispatch();

  //   const [Participantlist, setParticipantlist] = useState([]);

  const [formLoading, setFormLoading] = useState(false);

  const [filteredUser, setFilteredUser] = useState([]);

  const ChatlistState = useSelector(
    (state) => state.setting?.allchat?.data?.data
  );

  const FilteredUserlistState = useSelector(
    (state) => state.setting?.filteredUser?.data?.users
  );

  useEffect(() => {
    const existingParticipantIds = new Set(
      ChatlistState?.filter((data) => data._id === chatId)[0]?.participants?.map((p) => p._id) || []
    );

    const updatedData = FilteredUserlistState?.map(
      ({ firstName, ...rest }) => ({
        title: firstName,
        ...rest,
      })
    ).filter((data) =>
      data._id !== window.sessionStorage.getItem("user_id") &&
      !existingParticipantIds.has(data._id)
    );
    setFilteredUser(updatedData);
  }, [FilteredUserlistState, chatId, ChatlistState]);

  //   useEffect(() => {
  //     const updatedData = Chatlist?.filter((data)=>data._id===chatId)[0]?.participants?.map(
  //         ({ firstName, ...rest }) => ({
  //           title: firstName,
  //           ...rest,
  //         })
  //       );
  //     setParticipantlist(updatedData);
  //   }, [chatId,Chatlist]);

  useEffect(() => {
    dispatch(GetFilteredUserAction());
  }, []);

  const validationSchemaGroup = Yup.object({
    groupName: Yup.string().required("Text is required"),
    selectedOptions: Yup.array()
      .required("Please select at least one option")
      .min(1, "Minimum one participant is required to create a group."),
    // participants: Yup.array()
    //   .min(2, "Minimum two participant is required to create a group.")
    //   .required("Participants is required"),
  });

  return (
    <Modal
      open={AddPersonChat}
      onClose={() => {
        handleClose()
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            mb: 2.5,
          }}
        >
          <Typography
            fontFamily={FontFamily.Poppins}
            fontWeight={fontWeight.W600}
            fontSize={fontSize.h3.large}
            color={ThemeColor.BLACK}
          >
            Add Person to Chat
          </Typography>
          <IconButton
            size="small"
            onClick={() => handleClose()}
            sx={{ color: "#667085" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <Formik
          initialValues={{
            selectedOptions: [],
          }}
          // validationSchema={validationSchema}
          onSubmit={async (values, { resetForm }) => {
            setFormLoading(true);
            let participants = [];
            if (values.selectedOptions) {
              values.selectedOptions?.map((data) => {
                participants.push(data._id);
              });
            }

            let payload = {
              newParticipants: participants,
            };

            await AddPersonToGroupChatService(chatId, payload)
              .then((res) => {
                if (res.status === 200) {
                  // //(res);
                  dispatch(GetUserChatAction());
                  setFormLoading(false);
                  handleClose();
                  dispatch(showSnackbar(res.data.message, "success"));

                  resetForm();
                }
              })
              .catch((e) => {
                setFormLoading(false);
                dispatch(showSnackbar(apiErrorMessage(e), "error"));
              });
          }}
        //   validationSchema={validationSchemaGroup}
        >
          {({
            values,
            errors,
            handleBlur,
            handleChange,
            touched,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form className="d-flex justify-content-center">
              <Box
                className="addcatalog-container"
                sx={{
                  width: { sm: "100%", xs: "100%", md: "100%", lg: "100%" },
                }}
              >
                <FormGroup className="mt-3">
                  <MultiSelectAutocomplete
                    options={filteredUser}
                    label="Selected Users..."
                    disabled={true}
                    value={Participantlist}
                  />
                </FormGroup>

                <FormGroup className="mt-3">
                  <MultiSelectAutocomplete
                    options={filteredUser}
                    label="Select user..."
                    value={values.selectedOptions}
                    filtertext={true}

                    onChange={(newValue) => {
                      //  console.log(newValue);
                      setFieldValue("selectedOptions", newValue);
                    }}
                  />
                  {errors.selectedOptions && (
                    <div className="mt-2" style={{ color: "red" }}>
                      {errors.selectedOptions}
                    </div>
                  )}
                </FormGroup>

                <div className="d-flex justify-content-center align-items-center h-100 w-100 mt-3">
                  <div className="px-3">
                    <CustomButton
                      variant="contained"
                      type="submit"
                      backgroundColor={ThemeColor.PURPLE}
                      color={ThemeColor.WHITE}
                    >
                      Submit
                    </CustomButton>
                  </div>
                </div>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};
